import  React, { useState, useEffect } from "react";
import { Modal, Row, InputNumber, Button, Table, Tooltip, Input, Select} from "antd";
import { MenuOutlined, MinusCircleOutlined, PlusCircleOutlined} from "@ant-design/icons";
import {  toSentenceCase } from '../../utils/utils';

const { Option } = Select;

// const initialVisit = [{
//     "period_name": "",
//     "period_id": 1,
//     "period_order_index": 1,
//     "no_of_visits": "",
//     "visit_type_id": 1,
//     "visit_type": "",
//     "visits": [],
//     "visit_notes": [""],
//     "soaDismissedActivity":[],
//    // "weeks": [1]
//   }]


  const AntdTable = React.memo(({ dataSource, columns, visitTypes }) => {   
    return (  
      <Table  
        dataSource={dataSource} 
        columns={columns}  
        pagination={false}
        showHeader={true}
        visitTypes={visitTypes}
       />   
    );
   }, (prevProps, nextProps) => {  
      return (prevProps.dataSource === nextProps.dataSource && prevProps.visitTypes === nextProps.visitTypes  )
    });   

const SOAConfigure = (props) => { 

    const { visible , visitTypeLib, cancelHandler, submitHandler, soaOncologyFlag, periodDataDetails } = props
    const [requiredValidation, setRequiredValidation] = useState(false)
    const [detailData, setDetailData] = useState(null); 
    const [visitTypes, setVisitTypes] = useState([]);
    const [defaultVisit, setDefaultVisit] = useState([]);

    const cancelChanges = () => {
      setDetailData(periodDataDetails)
      cancelHandler()
    }

    useEffect(() => {
        // let visits = soaOncologyFlag ? ['Screening',  "Fixed Cycle", "Repeating Cycle", "End of Treatment", "Follow-up"] : ['Screening', "Treatment", "Follow-up"]
        let visits = visitTypeLib;
        setVisitTypes(visits)
        let tempDefaultVisit = visits.map((visit, index) => {
          return {
            "period_name": toSentenceCase(visit.visit_type),
            "period_id": index + 1,
            "period_order_index": index + 1,
            "no_of_visits": 1,
            "visit_type_id": visit.visit_type_id,
            "visit_type": visit.visit_type,
            "visits": [1],
            "visit_notes": [""],
            "soaDismissedActivity":[],
            [soaOncologyFlag ? 'days' : 'weeks']: [null]
          }
        })
        setDefaultVisit(tempDefaultVisit)
    }, [visitTypeLib])

    useEffect(() => {
      if(defaultVisit.length === 0) return;
      if(!periodDataDetails || periodDataDetails?.length === 0) {
        setDetailData(defaultVisit)
      } else {
        setDetailData(periodDataDetails)
      }
    }, [periodDataDetails, defaultVisit])

    const checkEmpty = () => { 
      return detailData.every(obj =>  
          obj.period_name !== '' && obj.visit_type !== '' &&  obj.no_of_visits !== '' && !isNaN(obj.no_of_visits)
      );  
    }
    const submitConfigure = () => { 
      const allKeysHaveValues = checkEmpty()
      setRequiredValidation(!allKeysHaveValues)
      // Update visits into ascending order
      let newPeriodType = JSON.parse(JSON.stringify(detailData))
      let sum = newPeriodType.reduce((a, b) => a + b.no_of_visits, 0);
      let visitsArray = Array.from({ length: sum }, (v, i) => i).map((k, i) => i+1 )
      newPeriodType.forEach((period, index) => {
        const visits = visitsArray.splice(0, period.no_of_visits)
        period.visits = visits
      })    
      allKeysHaveValues && submitHandler(newPeriodType, detailData)
    }


    const addVisit = (evt, row) => {  
      const allKeysHaveValues = checkEmpty()
      if(!allKeysHaveValues) return
      let newData = JSON.parse(JSON.stringify(detailData))
      let sum = newData.reduce((a, b) => a + b.no_of_visits, 0);
      const index = newData.findIndex((item) => row.period_order_index === item.period_order_index)
      let newElement = {
        period_name: newData[index].period_name,
        period_id: newData[index].period_id,
        period_order_index: newData[index].period_order_index,
        no_of_visits: 1,
        visit_type_id: newData[index].visit_type_id,
        visit_type: newData[index].visit_type,
        visits: [sum+1],
        visit_notes: [""],
        [soaOncologyFlag ? 'days' : 'weeks']: [null]
      }
      newData.splice(index+1, 0, newElement); 
      newData = [...newData].map((item, index) => (({...item, period_order_index: index + 1, period_id: index + 1, }))) 
      setDetailData( newData )
    }

    const removeVisit = (evt, row) => {
      let newData = [...detailData];
      if(newData.length === 1) return;
      const index = newData.findIndex((item) => row.period_order_index === item.period_order_index);
      newData = [...newData]
      newData.splice(index, 1); 
      newData = [...newData].map((item, index) => (({...item, period_order_index: index + 1, period_id: index + 1, }))) 
      setDetailData( newData )
    }

    const [validationMsg, setValidationMsg] = useState('')
    const saveHandler = (e, record) => {  
      let value = e.target.value;  
      if(value === '') return 
      if( value.length > 500) {
        setValidationMsg('Period Name cannot exceed 500 characters.')
        value=''
      } else {
        setValidationMsg('')
      }
      setDetailData(prevData => prevData.map(item => {  
        if (item.period_order_index === record.period_order_index) {  
          return {  
            ...item,  
            period_name: value,  
          };  
        }  
        return item;  
      }));  
    };
   
    const visitSelectionHandler = (e, record) => {  
      const newData = [...detailData];
      const index = newData.findIndex((item) => record.period_order_index === item.period_order_index);  
      const item = { visit_type: e, visit_type_id: visitTypes?.find(k => k.visit_type === e)?.visit_type_id};
      newData.splice(index, 1, { 
        ...record,
        ...item
      });  
      setDetailData(newData);
    }
    function visitHandler(existingVisit, newVisit, value) { 
      let arr = []
      if(existingVisit) {
      if( existingVisit.length < newVisit.length) {
      arr = newVisit.map((k, i) => existingVisit[i] ?? null)
      } else if ( existingVisit.length > newVisit.length) {
      arr = existingVisit.splice(0, value)
      }
      } else {
      arr = newVisit
      }
      return arr;  
    }   
    
    const updateDetailsHandler = (value,  record) => {
      const newData = [...detailData];
      const index = newData.findIndex((item) => record.period_order_index === item.period_order_index);
      let visit_arr
      if(newData[index]?.visits?.length > value) {
        visit_arr = Array.from({ length: value }, (v, i) => newData[index].visits[i] ?? newData[index].visits[newData[index].visits.length - 1 ] + 1); 
      } else if(newData[index]?.visits?.length < value) {
        visit_arr = Array.from({ length: value }, (v, i) => newData[index].visits[i] ?? newData.map(k => k.visits).flat()?.length + 1); 
      } 
      else {
        //visit_arr = Array.from({ length: value }, (v, i) => i + 1); 
        visit_arr = Array.from({ length: Math.max(...newData.map(k => k.visits).flat()) }, (v, i) => i + 1);  
      }
      const week_arr = Array.from({ length: value }, () => null);   
      const item = { no_of_visits: value , visits:  visit_arr};
      const notes = visit_arr?.map((k, idx) => record.visit_notes[idx] ?? '')
      let dayWeekDict
      const day_week_selection = soaOncologyFlag ? 'days' : 'weeks';
      const selection_dict = visitHandler(newData[index][day_week_selection], week_arr, value)  
      dayWeekDict = { [day_week_selection]:selection_dict } 
      newData.splice(index, 1, { 
        ...record,
        ...item,
        ...dayWeekDict,
        visit_notes: notes
      });  
      setDetailData(newData);   
    }

    const changeVisitsHandler = (e, record) => { 
      let value = parseInt(e);
      if(value === '' || isNaN(value)) return
      if(value > 100 ) {
        value = 100
      }
      updateDetailsHandler(value, record)
    }

    // const visitsHandler = (e, record ) => { 
    //   let value = parseInt(e.target.value);
    //   if(value == '') return
    //   if(value > 100 ) {
    //     value = 100
    //   }
    //   updateDetailsHandler(value,  record)
    // }


    const detailColumns =  [
      {
        title:'',
        dataIndex: '',
        key:'',
        width: 10,
        render: (_, record) => {
          return  <MenuOutlined style={{paddingRight: '20px'}}/> 
      }
      },
      {
        title: 'Period Name',
        dataIndex: 'period_name',
        key: 'period_name',
        width: 500,
        editable: true,
        render: (_, record) => {
            return (<>
              <Tooltip title={record['period_name']}> 
               <Input style={{ width: "300px", fontSize: 14}} defaultValue={record['period_name']} max={500} onBlur={(e) => saveHandler(e, record)} required={true} placeholder="Enter period name"/>
              </Tooltip>
            </>
            ) 
            
        }
        }, 
      {
      title: 'Type',
      dataIndex: 'visit_type',
      key: 'visit_type',
      width: 400,
      render: (_, record) => {
        return <Select
          className="therapeutic-area-select"
          style={{ width: "200px", fontSize: 14}}
          defaultValue={record['visit_type'] || ''}
          onChange={(e)=> visitSelectionHandler(e, record)}
          virtual={false}>
          {visitTypes?.map((o) => {
            return (
              <Option value={o?.visit_type} key={o?.visit_type}>
                {toSentenceCase(o?.visit_type)}
              </Option>
            );
          })}
        </Select>
    }
      },
      {
      title: 'No of Visits',
      dataIndex: 'no_of_visits',
      key: 'no_of_visits',
      width: 300,
      render: (_, record) => {
          return <InputNumber style={{ width: "100px", fontSize: 14}} defaultValue={record['no_of_visits']} min={1} max={100} required={true} onChange={(e) => changeVisitsHandler(e, record)} 
          // onBlur={(e)=> visitsHandler(e, record)}
           />
      
        }
      }, 
      {
        title: ' ',
        dataIndex: 'action',
        key: 'action',
        width: 320,
        editable: false,
        render: (_, record) => {
          return (
            <>
              <PlusCircleOutlined style={{paddingRight: '20px'}} onClick={(e) => addVisit(e, record)} />
              <MinusCircleOutlined onClick={(e) => removeVisit(e, record)} />
            </>
          )
        }
        
    }]

    const newDetailColumns = detailColumns.map((col) => {
      if (!col.editable) {
      return col;
  }

  return {
      ...col,
      onCell: (record) => ({
      record,
      editable: col.editable,
      dataIndex: col.dataIndex,
      title: col.title,
      saveHandler,
      }),
  };
  });  

    return (

    <Modal visible={visible} title="" 
        closable={
        periodDataDetails?.length > 0 ? true :false} 
        mask={false} 
        onCancel={cancelChanges} 
        footer={null} 
        style={{ top: 20 }} 
        centered={false} 
        maskClosable={false}
        wrapClassName="soaModal"
        >
      <Row className="configure-title">
      <span>Configure Schedule of Activities table</span>
      </Row>
      <br/>
      <Row>
       <AntdTable dataSource={detailData} key={detailData?.length} columns={newDetailColumns} visitTypes={visitTypes} />
      </Row> 

       {requiredValidation && validationMsg === '' && ( <Row><span style={{color: 'red'}}>Fill required fields</span></Row>)}
       {validationMsg !=='' &&  (<span style={{color: 'red', display: 'inline-block'}} > {validationMsg} </span>)}
        <Row style={{justifyContent: 'center', paddingTop: '20px'}}>
        <Button type="primary" className="step-btn create-btn" onClick={submitConfigure}>
          <span> {periodDataDetails?.length > 0 ? 'Update' : 'Create'} </span>
        </Button>
      </Row>

     </Modal> 
    )
}

export default SOAConfigure;